import Frame from "../components/Frame";
import RetryPanel from "../components/RetryPanel";
import ui from "../components/ui.module.css";
import { doneLabel, purposeLabel } from "../data/workLabels";

// Work this learner really did and finished, newest first (Handoff 007 §8).
// It is history, not a curriculum browser: nothing unopened, future or merely
// approved appears here.
const MyLearning = ({ items, saving, retry, onOpen, onBack }) => (
  <Frame narrow onBack={onBack}>
    <h1 className={ui.learnerTitle}>My Learning</h1>
    {items?.length ? (
      <ul className={ui.workList}>
        {items.map((item) => (
          <li key={item.attemptId}>
            <button
              type="button"
              className={ui.workItem}
              onClick={() => onOpen(item.attemptId)}
              disabled={saving}
            >
              <span>
                <span className={ui.workItemTitle}>{item.title || purposeLabel(item.purpose)}</span>
                <br />
                <span className={ui.meta}>{purposeLabel(item.purpose)}</span>
              </span>
              <span className={ui.workBadge}>{doneLabel(item.completedAt)}</span>
            </button>
          </li>
        ))}
      </ul>
    ) : (
      <p className={ui.subline}>When you finish some work, it will be here.</p>
    )}
    {retry && <RetryPanel onRetry={retry} saving={saving} />}
  </Frame>
);

export default MyLearning;
